<template>
  <logged-in-layout>
    <main>
      <h1>Messages</h1>
      <messages-list />
      <new-message-button />
    </main>
  </logged-in-layout>
</template>

<script>
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import MessagesList from './messages-list/messages-list'
  import NewMessageButton from './new-message-button/new-message-button'

  export default {
    components: {
      LoggedInLayout,
      MessagesList,
      NewMessageButton
    }
  }
</script>

<style module lang="less" src="./messages.less"></style>



// WEBPACK FOOTER //
// messages.vue?55b50390